// extracted by mini-css-extract-plugin
module.exports = {"scrollBarRoot":"useCustomScrollbar_scrollBarRoot__Mt3EP","propagate":"useCustomScrollbar_propagate__UZoMZ"};